import { Button, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";
import HeaderAdmin from "../../../components/HeaderAdmin/HeaderAdmin";
import "./styles.css";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { useContext, useState } from "react"; 
import api from "../../../services/axiosConfig";
import { Context } from "../../../hooks/useAuthContext";
import NovoDesconto from "./components/NovoDesconto";
import Swal from "sweetalert2";
import { FaArrowLeft } from "react-icons/fa";
import { Link } from "react-router-dom";

function Descontos() {
  const { exibirLogs } = useContext(Context);
  const [mesAno, setMesAno] = useState();
  const [loading, setLoading] = useState(false);
  
  const [filteredDescontos, setFilteredDescontos] = useState([]);
  const [allDescontos, setAllDescontos] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nomeApelido, setNomeApelido] = useState("");
  const [descontoEmEdicao, setDescontoEmEdicao] = useState(null);

  function handleMesAnoChange(date) {
    setMesAno(date);
  }

  async function fetchData(mesAnoParam) {
    try {
      setLoading(true);
      let params = {};
      if(mesAnoParam){
        const mes = String(mesAnoParam.getMonth() + 1).padStart(2, "0");
        const ano = mesAnoParam.getFullYear();
        params.date = `${mes}/${ano}`;
      }

      if(nomeApelido){
        params.search = nomeApelido;
      }

      const response = await api.get("/descontos", { params });
      const data = response.data || [];
      
      setAllDescontos(data);
      setFilteredDescontos(data); 

    } catch (error) {
      exibirLogs && console.error("Erro ao buscar descontos:", error);
      setAllDescontos([]);
      setFilteredDescontos([]);
    } finally {
      setLoading(false);
    }
  }

  async function handleSearch() {
    if (!nomeApelido) {
      await fetchData(mesAno);
      return;
    }

    setLoading(true);
    
    const lowercasedFilter = nomeApelido.toLowerCase();
    const localResults = allDescontos.filter(item =>
      item.nome.toLowerCase().includes(lowercasedFilter) ||
      (item.apelido && item.apelido.toLowerCase().includes(lowercasedFilter))
    );

    if (localResults.length > 0) {
      setFilteredDescontos(localResults);
      setLoading(false);
      console.log("Resultados encontrados localmente.");
    } else {
      console.log("Nenhum resultado local. Buscando no backend...");
      await fetchData(mesAno);
    }
  }

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Tem certeza?",
      text: "Essa ação é irreversível",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, apagar!",
      cancelButtonText: "Cancelar"
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/descontos/apagar-desconto/${id}`);
        setNomeApelido(""); 
        fetchData(mesAno);
      } catch (error) {
        exibirLogs && console.error(error);
      }
    }
  };
  
  const handleEdit = (desconto) => {
    setDescontoEmEdicao(desconto);
    setIsModalOpen(true);
  };
  
  const handleNew = () => {
    setDescontoEmEdicao(null);
    setIsModalOpen(true);
  }

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <div>
      <HeaderAdmin />
      <div className="infoPage">
        <span>
          <Link to={'/'} style={{ textDecoration: 'none', color: '#000'}}>
            <FaArrowLeft size={16} /> Descontos
          </Link>
        </span>
      </div>
      <div className="miniWrapper" style={{ marginTop: 20 }}>
        <Row style={{ display: "flex", justifyContent: "space-between" }}>
          <Col md={3} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label for="mesAno">Data</Label>
              <DatePicker
                selected={mesAno}
                onChange={handleMesAnoChange}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                locale={ptBR}
                className="dateInputRelatorio form-control"
                placeholderText="Selecione mês e ano"
                id="mesAno"
                autoComplete="off"
              />
            </FormGroup>
          </Col>
          <Col md={3} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label for="nomeApelido">Nome/Apelido</Label>
              <Input
                id="nomeApelido"
                type="text"
                value={nomeApelido}
                onChange={(e) => setNomeApelido(e.target.value)}
                placeholder="Filtre por nome ou apelido..."
              />
            </FormGroup>
          </Col>

          <Col md={2} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label>Ações</Label>
              <Button color="secondary" onClick={handleSearch}>
                Buscar
              </Button>
            </FormGroup>
          </Col>
          
          <Col md={2} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label>Ações</Label>
              <Button color="secondary" onClick={handleNew}>
                Novo desconto
              </Button>
            </FormGroup>
          </Col>
        </Row>
        
        <Table striped>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Apelido</th>
              <th>Observação</th>
              <th>Valor descontado</th>
              <th>Tipo conta</th>
              <th>Referência</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ textAlign: "center" }}>Carregando...</td></tr>
            ) : filteredDescontos.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: "center" }}>Não há dados</td></tr>
            ) : (
              filteredDescontos.map((desconto) => (
                <tr key={desconto._id}>
                  <td>{desconto.nome}</td>
                  <td>{desconto.apelido || "N/A"}</td>
                  <td>{desconto.obs}</td>
                  <td>{desconto.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                  <td>{desconto.tipoConta}</td>
                  <td>{desconto.date}</td>
                  <td>
                    <Button color="success" onClick={() => handleEdit(desconto)} style={{ width: "100%", marginBottom: '5px' }}>
                      Editar
                    </Button>
                    <Button color="danger" onClick={() => handleDelete(desconto._id)} style={{ width: "100%" }}>
                      Excluir
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <NovoDesconto
        isOpen={isModalOpen}
        toggle={toggleModal}
        fetchData={() => {
          setNomeApelido("");
          fetchData(mesAno); 
        }}
        mesAno={mesAno}
        descontoParaEditar={descontoEmEdicao}
      />
    </div>
  );
}

export default Descontos;